<template>  
    <div class="containerFull">
      <div class="p-grid p-mb-5">
        <div class="p-md-4">
          <img src="../assets/layout/images/que_ofrecemos_qualitycare.png" alt="">
          <h1 class="p-mt-6 titulo-admin">{{ $t("messages.contactUs") }}</h1>
          <p><strong>Bogotá</strong></p>
          <p>{{ $t("messages.addressUbication") }}</p>
          <p>{{ $t("messages.addressOfOffice") }}</p>
          <p>(031)3849060/61/62-69</p>
          <p><a href="mailto:adminsalas@caqc.co">servicioalcliente@qualitycare.com.co</a></p>
          <p>{{ $t("messages.fullSchedule") }}</p>
        </div>
        <div class="p-md-8">          
          <h5 style="border-bottom: 1px solid #cfcfcf;padding-bottom:10px">
            {{ $t("messages.contactUsDescription") }}
          </h5>
          <BotonPolitica/>
          <div class="p-fluid p-formgrid p-grid p-mt-6">
            <div class="p-field p-col-12 p-md-7">
              <label for="nombre">{{ $t("messages.nameAndLastName") }}</label>
              <InputText id="nombre" type="text" v-model.trim="nombre" />
            </div>
            <div class="p-field p-col-12 p-md-7">
              <label for="email">{{ $t("messages.email") }}</label>
              <InputText id="email" type="email" v-model.trim="email" />
            </div>
            <div class="p-field p-col-12 p-md-7">
              <label for="telefono">{{ $t("messages.contactPhone") }}</label>
              <InputText id="telefono" type="text" v-model.trim="telefono" />
            </div>
            <div class="p-field p-col-12">
              <label for="contenido">{{ $t("messages.yourMessage") }}</label>
              <Textarea id="contenido" rows="10" v-model.trim="comentario" />
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="verificacion"
                >{{ $t("messages.howMuchIs") }} {{ numero1 }}+{{ numero2 }}</label
              >
              <InputText
                id="verificacion"
                type="number"
                v-model.trim="resultado"
              />
            </div>
            <div class="p-field p-col-12 p-text-center">
              <Button
                :label="$t('messages.send')"
                 name="enviar"
                style="width:200px;margin:0px auto;justify-content:center"
                @click="enviarCorreo"
                :disabled="enviando">{{ $t('messages.send') }}<i class="pi pi-spin pi-spinner p-ml-2" style="font-size: 1rem" v-if="enviando"></i></Button>            
            </div>
          </div>
        </div>
      </div>
    </div>  
</template>

<script>
import UsuariosService from "../service/usuarios.service";
import BotonPolitica from "./boton_politicas.vue";
export default {
  metaInfo: {
    title: 'Registro - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Registro de usuario',
        content: 'Registro de usuario en QualityCare',
      },
    ],
  },
  components: {
    BotonPolitica
  },
  data() {
    return {
      usuariosService: null,
      nombre: "",
      email: "",
      telefono: "",
      comentario: "",
      verificacion: 0,
      resultado: 0,
      numero1: 0,
      numero2: 0,
      enviando: false
    };
  },
  created() {
    this.usuariosService = new UsuariosService();
  },
  mounted() {
    this.numero1 = this.getRandomInt(10, 20);
    this.numero2 = this.getRandomInt(10, 20);
  },
  methods: {
    enviarCorreo() {
      if (this.resultado != this.numero1 + this.numero2) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "La verificación no fue exitosa, intentelo nuevamente",
          life: 3000,
        });
        this.numero1 = this.getRandomInt(10, 20);
        this.numero2 = this.getRandomInt(10, 20);
        return false;
      }
      this.enviando = true;
      this.usuariosService
        .enviarCorreo({
          nombre: this.nombre,
          email: this.email,
          telefono: this.telefono,
          comentario: this.comentario,
        })
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Contactame",
            detail: "Su mensaje ha sido enviado correctamente, gracias",
            life: 3000,
          });
          this.nombre = "";
          this.email = "";
          this.telefono = "";
          this.comentario = "";
          this.numero1 = this.getRandomInt(10, 20);
          this.numero2 = this.getRandomInt(10, 20);
          this.resultado = 0;
          this.enviando = false;
        })
        .catch((err) => {          
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Fallo el envio del mensaje, intentelo nuevamente por favor",
            life: 3000,
          });
          this.enviando = false;
          console.log(err);
        });
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
  }
};
</script>

<style scoped>
h1{
  margin: 10px 0px !important;  
}
.containerFull{
  padding: 20px 300px;
}
p{
  font-size: 18px;
  margin: 0px;
}
@media screen and (max-width: 1740px) {
  .containerFull{
    padding: 20px 40px;
  }
}
@media screen and (max-width: 800px) {
  .containerFull{
    padding: 20px 10px;
  }
  img{
    height: 290px;
    margin: 0px auto;
  }
}
</style>
